module.exports = __webpack_public_path__ + "img/Condominio_das_Americas_BlocoKidsJogos.e9072904.jpg";